import { onDelegatedClick, initAllModules, quoteattr } from './functions.js';

export default function PhotolistModule(element, args) {

    args = Object.assign({
        maxFiles: 99
    }, element.dataset, args);

    let qs = element.querySelector.bind(element);

    let container = qs('.photolist__container');
    let empty = qs('.photolist__empty');

    args.value = args.value ? JSON.parse(args.value) : [];


    let targetPath = args.targetPath || 'booking-inventory-files/{{default_filename}}';

    let index = 0;

    function init() {
        initUploader();
        bindEvents();

        setInitialValues();
        refreshScreen();
    }

    function initUploader() {
        Kodens.uploader({
            trigger: qs('.js-add-photos'),
            // maxFiles: 1,
            optimize: true,
            resize: {
                width: 2000,
                height: 2000,
                type: 'contain'
            },
            publicKey: window.KODENS_UPLOAD_KEY,
            allowedSources: [Kodens.SOURCE_LOCAL],
            targetPath: targetPath,
            callback: function(result) {
                if (result.length === 0) { return; }
                result.forEach(function(file) {
                    addItem(file);
                });

                refreshScreen();
            }
        });
    }

    function bindEvents() {
        onDelegatedClick(element, '.photolist__delete', function(event) {
            event.preventDefault();
            event.target.closest('.photolist__item').remove();

            refreshScreen();
        });
    }

    function refreshScreen() {
        if (countItems() === 0) {
            showEmpty();
        } else {
            showContainer();
        }
    }

    function showEmpty() {
        container.style.display = 'none';
        empty.style.display = 'block';
    }

    function showContainer() {
        empty.style.display = 'none';
        container.style.display = 'flex';
    }

    function addItem(file) {

        if (countItems() >= args.maxFiles) {
            toastr.info(window.I18N.MAX_FILES_REACHED.replace('{0}', args.maxFiles));
            return;
        }

        let html =  itemTemplate;
        html =  html.replace('{url}', file.url);
        html =  html.replace('{index}', index);
        html =  html.replace('{value}', quoteattr(JSON.stringify(file)));
        html =  html.replace('{field}', args.field);
        index++;
        container.insertAdjacentHTML('beforeend', html);
    }

    function setInitialValues() {
        args.value.forEach(function(file) {
            addItem(file);
        });
    }

    function countItems() {
        return container.querySelectorAll('.photolist__item').length;
    }

    init();
    
    return this;

};

const itemTemplate = `<div class="photolist__item">
    <img src="{url}" alt="">
    <a href="" class="photolist__delete">&times;</a>
    <input type="hidden" name="{field}[{index}]" value="{value}">
</div>` 